import { useNavigate } from '@reach/router';
import Typography from 'apps/GiftRedemption/components/Typography';
import Video from 'apps/GiftRedemption/components/Video';
import Layout from '../components/Layout';
import { ReactComponent as CauzeLogo } from 'assets/images/brand/cauze-logotype-accent.svg';

const GiftMessage = () => {
  const navigate = useNavigate();
  return (
    <button
      className="bg-[#E8E4F9] py-3 px-6 rounded-[20px] min-h-[212px] flex flex-col border-none cursor-pointer"
      onClick={() => navigate('gift-redeem/landing')}
    >
      <div className="flex-1 flex items-center">
        <Typography
          weight="bold"
          className="text-[18px] text-center"
          lineHeight="normal"
        >
          “ Jane - Thanks for the help last week. Here’s a little thank you. I
          hope you do some good with it: ”
        </Typography>
      </div>
      <Typography className="text-center" color="secondary">
        tap to continue →
      </Typography>
    </button>
  );
};

const ViewScan = () => {
  return (
    <Layout className="pt-12 px-8">
      <div className="flex flex-col gap-y-3 mb-10">
        <Typography className="text-[48px] text-center" weight="bold">
          Sara
        </Typography>
        <Typography className="text-center text-[18px]" color="secondary">
          sent you something
        </Typography>
      </div>
      <div className="mb-6">
        <GiftMessage />
      </div>
      <div className="flex justify-center">
        <Typography color="secondary" className="text-[14px] my-auto">
          powered by
        </Typography>
        <CauzeLogo height={16} width={96} />
      </div>
    </Layout>
  );
};

export default ViewScan;
